<style>
.vs-card--content {
    margin-bottom: 0;
}
.disabledlist {
    color: #bdc3c7;
}

.vs-alert .vs-icon {
    font-size: 1.5rem;
}

.vs-alert {
    font-size: 1.5rem;
}

.last-state {
    font-size: 2rem;
}
.disabledText{
        user-select: none;
    }
</style>

<template>
    <div>
        <div class="w-full vx-col mb-base">
            <!-- <vs-card class="p-4">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Checking and Packing</h4>
                </div>
                <div class="flex items-center">
                    <vs-dropdown vs-trigger-click>
                        <vs-button class="mb-4 mr-1 btn md:mb-0" icon="settings_applications">Process</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="finishPacking"> Finish Packing </vs-dropdown-item>
                            <vs-dropdown-item @click="cancelPacking"> Cancel Packing </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    <vs-dropdown vs-trigger-click>
                        <vs-button class="mb-4 mr-1 btn md:mb-0" icon="print">Print</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="printPackingList"> Packing List </vs-dropdown-item>
                            <vs-dropdown-item @click="printPackingLabel"> Packing Label </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </vs-card>-->
            <vs-popup :active.sync="packingPopup.show" title="Packing List">
                <vs-table
                    :data="packingPopup.data"
                    hoverFlat
                    stripe
                    single
                    v-model="packingPopup.selected"
                >
                    <template slot="thead">
                        <vs-th>No.</vs-th>
                        <vs-th>Packing ID</vs-th>
                        <vs-th>Product Code</vs-th>
                        <vs-th>Description</vs-th>
                        <vs-th>Qty</vs-th>
                        <vs-th>UoM ID</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
                            <vs-td>{{ index + 1 }}</vs-td>
                            <vs-td>{{ tr.packing_id }}</vs-td>
                            <vs-td>{{ tr.product_code }}</vs-td>
                            <vs-td>{{ tr.description }}</vs-td>
                            <vs-td>{{ tr.base_qty }}</vs-td>
                            <vs-td>{{ tr.base_uom }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <div class="flex flex-wrap items-center justify-between mt-5">
                    <div class="flex items-center"></div>
                    <div class="flex items-center">
                        <vs-button
                            class="mb-4 mr-2 md:mb-0"
                            type="flat"
                            :disabled="!packingPopup.selected.id"
                            @click="removePacking"
                        >Remove Item</vs-button>
                        <vs-button
                            class="mb-4 md:mb-0"
                            @click="updatePacking"
                            :disabled="!packingPopup.selected.id"
                        >Update Packing</vs-button>
                    </div>
                </div>
            </vs-popup>
            <vs-popup title="Update Packing" :active.sync="packingUpdate">
                <div class="con-exemple-prompt">
                    <vs-input v-model="packing_update.packing_id" class="w-full mb-2" label="ID" disabled/>
                    <vs-input v-model="packing_update.height" class="w-full mb-2" label="Height (cm)"/>
                    <vs-input v-model="packing_update.length" class="w-full mb-2" label="Length (cm)"/>
                    <vs-input v-model="packing_update.width" class="w-full mb-2" label="Width (cm)"/>
                    <vs-input v-model="packing_update.weight" class="w-full mb-2" label="Weight (kg)"/>
                </div>
                <vs-button
                    class="mt-5 mb-4 md:mb-0"
                    @click="savePacking"
                >Save</vs-button>
            </vs-popup>
        </div>
        <vs-popup title="Checking Packing" :active.sync="showFull" fullscreen>
            <div class="flex items-center mb-10">
                <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                <h4 style="margin-left: 10px">Checking and Packing</h4>
                <h4 style="margin-left: 10px"></h4>
                <vs-button @click="printPackingLabel()" class="mr-1 btn" type="border" v-if="showBtnPrint">Print Packing Label</vs-button>
            </div>
            <vs-alert
                active="true"
                icon-pack="feather"
                icon="icon-alert-circle"
                class="mb-10"
            >{{ alert }}</vs-alert>
            <vs-tabs :value="tab_value">
                <!-- <vs-tab label="Container" @click="focusInput('container')">
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mt-5 mb-3 vx-row">
                            <div class="w-1/3 vx-col">Movement / Container ID*</div>
                            <div class="w-2/3 vx-col">
                                <vs-input
                                    v-model="data.movement_id_send"
                                    :disabled="state != 'container'"
                                    @keyup.enter="scanContainer"
                                    size="medium"
                                    ref="container"
                                />
                            </div>
                        </div>
                    </div>
                </vs-tab>-->
                <vs-tab label="Product">
                    <div class="mt-5 mb-3 vx-row">
                        <div class="w-full vx-col lg:w-1/4">
                            <div class="mb-3 vx-row">
                                <div class="w-1/3 vx-col">Product ID*</div>
                                <div class="w-2/3 vx-col">
                                    <vx-input-group>
                                        <vs-input
                                            v-model="scan.product_code"
                                            :disabled="state != 'product'"
                                            @keyup.enter="scanProduct"
                                            ref="product"
                                            @paste.prevent
                                        />
                                        <template slot="append">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    size="small"
                                                    color="primary"
                                                    icon-pack="feather"
                                                    icon="icon-search"
                                                    :disabled="state != 'product'"
                                                ></vs-button>
                                            </div>
                                        </template>
                                    </vx-input-group>
                                </div>
                            </div>
                            <div class="mb-3 vx-row">
                                <div class="w-1/3 vx-col">Stock Type</div>
                                <div class="w-2/3 vx-col">
                                    <vx-input-group>
                                        <vs-input
                                            v-model="scan.stock_type"
                                            :disabled="state != 'product'"
                                            @keyup.enter="scanProduct"
                                        />
                                        <template slot="append">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    size="small"
                                                    color="primary"
                                                    icon-pack="feather"
                                                    icon="icon-search"
                                                    :disabled="state != 'product'"
                                                ></vs-button>
                                            </div>
                                        </template>
                                    </vx-input-group>
                                </div>
                            </div>
                        </div>
                        <div class="w-full vx-col lg:w-1/4">
                            <div class="mb-3 vx-row">
                                <div class="w-1/3 vx-col">Multiplier</div>
                                <div class="w-2/3 vx-col">
                                    <vs-input
                                        class="w-full"
                                        v-model="scan.multiplier"
                                        :disabled="state != 'product'"
                                        @keyup.enter="scanProduct"
                                    />
                                </div>
                            </div>
                            <div class="mb-3 vx-row">
                                <div class="w-1/3 vx-col">UoM</div>
                                <div class="w-2/3 vx-col">
                                    <vx-input-group>
                                        <vs-input
                                            v-model="scan.uom"
                                            :disabled="state != 'product'"
                                            @keyup.enter="scanProduct"
                                        />
                                        <template slot="append">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    size="small"
                                                    color="primary"
                                                    icon-pack="feather"
                                                    icon="icon-search"
                                                    :disabled="state != 'product'"
                                                ></vs-button>
                                            </div>
                                        </template>
                                    </vx-input-group>
                                </div>
                            </div>
                        </div>
                        <div class="w-full vx-col lg:w-1/4">
                            <div class="mb-3 vx-row">
                                <div class="w-1/3 vx-col">Pack ID</div>
                                <div class="w-2/3 vx-col">
                                    <vs-input
                                        class="w-full"
                                        v-model="scan.pack_id"
                                        :disabled="state != 'product'"
                                        @keyup.enter="scanProduct"
                                    />
                                </div>
                            </div>
                            <div class="mb-3 vx-row">
                                <div class="w-1/3 vx-col">Batch</div>
                                <div class="w-2/3 vx-col">
                                    <vs-input
                                        class="w-full"
                                        v-model="scan.batch"
                                        :disabled="state != 'product'"
                                        @keyup.enter="scanProduct"
                                    />
                                </div>
                            </div>
                            <div class="mb-3 vx-row">
                                <div class="w-1/3 vx-col">Expired Date</div>
                                <div class="w-2/3 vx-col">
                                    <flat-pickr
                                        class="w-full"
                                        v-model="scan.expired_date"
                                        :disabled="state != 'product'"
                                        @keyup.enter="scanProduct"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
                <vs-tab label="Packaging">
                    <div class="mt-5 mb-3 vx-row">
                        <div class="w-full vx-col lg:w-1/4">
                            <div class="mt-5 mb-3 vx-row">
                                <div class="w-1/3 vx-col">Packing ID</div>
                                <div class="w-2/3 vx-col">
                                    <vs-input
                                        class="w-full"
                                        v-model="packing.packing_id"
                                        :disabled="state != 'packing'"
                                    />
                                </div>
                            </div>
                            <div class="mt-5 mb-3 vx-row">
                                <div class="w-1/3 vx-col">Packaging Type*</div>
                                <div class="w-2/3 vx-col">
                                    <vs-input
                                        class="w-full"
                                        v-model="packing.packing_code"
                                        ref="packing"
                                        :disabled="state != 'packing'"
                                        @keyup.enter="scanPacking"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="w-full vx-col lg:w-1/4">
                            <div class="mt-5 mb-3 vx-row">
                                <div class="w-1/3 vx-col">Length (cm)</div>
                                <div class="w-2/3 vx-col">
                                    <vs-input
                                        class="w-full"
                                        v-model="packing.length"
                                        :disabled="state != 'packing'"
                                        @keyup.enter="scanPacking"
                                    />
                                </div>
                            </div>
                            <div class="mt-5 mb-3 vx-row">
                                <div class="w-1/3 vx-col">Width (cm)</div>
                                <div class="w-2/3 vx-col">
                                    <vs-input
                                        class="w-full"
                                        v-model="packing.width"
                                        :disabled="state != 'packing'"
                                        @keyup.enter="scanPacking"
                                    />
                                </div>
                            </div>
                            <div class="mt-5 mb-3 vx-row">
                                <div class="w-1/3 vx-col">Height (cm)</div>
                                <div class="w-2/3 vx-col">
                                    <vs-input
                                        class="w-full"
                                        v-model="packing.height"
                                        :disabled="state != 'packing'"
                                        @keyup.enter="scanPacking"
                                    />
                                </div>
                            </div>
                            <div class="mt-5 mb-3 vx-row">
                                <div class="w-1/3 vx-col">Weight (kg)</div>
                                <div class="w-2/3 vx-col">
                                    <vs-input
                                        class="w-full"
                                        v-model="packing.weight"
                                        :disabled="state != 'packing'"
                                        @keyup.enter="scanPacking"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
            </vs-tabs>
            <h4 v-show="show == 'multiple' || show == 'single'" class="mb-5">{{ title }}</h4>
            <div style="max-height: 250px; overflow-y: auto">
                <div v-show="show == 'multiple'" class="mt-5">
                    <vs-collapse type="border" class="p-0" accordion>
                        <vs-collapse-item v-for="(detail, index) in data.details" :key="index">
                            <div
                                slot="header"
                                v-bind:class="{ disabledlist: detail.finished}"
                            >{{ (detail.tracking_reference ? '#' + detail.tracking_reference + ' - ' : '') + detail.reference + ' (' + detail.checked + '/' + detail.total + ')'}}</div>
                            <vs-button
                                color="primary"
                                type="filled"
                                size="small"
                                @click="packItem(detail.id, true)"
                                class="mr-2"
                            >Pack</vs-button>
                            <vs-button
                                color="primary"
                                type="filled"
                                size="small"
                                @click="viewPacking(detail.id)"
                                class="mr-2"
                            >View Packing</vs-button>
                            <vs-button
                                color="danger"
                                type="filled"
                                size="small"
                                @click="holdDo(detail)"
                                v-show="!detail.hold"
                                class="mr-2"
                            >Hold</vs-button>
                            <vs-button
                                color="success"
                                type="filled"
                                size="small"
                                @click="unholdDo(detail)"
                                v-show="detail.hold"
                            >Unhold</vs-button>
                            <vs-list v-for="(item, itemindex) in detail.items" :key="itemindex">
                                <vs-list-item
                                    v-bind:class="{disabledText}"
                                    :title="item.product_code + ' (' + item.checked +  '/' + item.total + ')'"
                                    :subtitle="item.description"
                                ></vs-list-item>
                            </vs-list>
                        </vs-collapse-item>
                    </vs-collapse>
                </div>
                <div v-show="show == 'single'" class="mt-5">
                    <vs-collapse type="border" class="p-0" accordion>
                        <vs-collapse-item
                            v-for="(detail, index) in single_detail"
                            :key="index"
                            :open="true"
                        >
                            <div
                                slot="header"
                                v-bind:class="{ disabledlist: detail.finished}"
                            >{{ 'Reference - ' + detail.reference + ' (' + detail.checked + '/' + detail.total + ')'}}</div>
                            <vs-button
                                color="primary"
                                type="filled"
                                size="small"
                                @click="packItem(detail.id, false)"
                                class="mr-2"
                            >Pack</vs-button>
                            <vs-button
                                color="primary"
                                type="filled"
                                size="small"
                                @click="viewPacking(detail.id)"
                                class="mr-2"
                            >View Packing</vs-button>
                            <vs-button
                                color="danger"
                                type="filled"
                                size="small"
                                @click="holdDo(detail)"
                                v-show="!detail.hold"
                                class="mr-2"
                            >Hold</vs-button>
                            <vs-button
                                color="success"
                                type="filled"
                                size="small"
                                @click="unholdDo(detail)"
                                v-show="detail.hold"
                            >Unhold</vs-button>
                            <vs-list v-for="(item, itemindex) in detail.items" :key="itemindex">
                                <vs-list-item
                                    v-bind:class="{disabledText}"
                                    :title="item.product_code + ' (' + item.checked +  '/' + item.total + ')'"
                                    :subtitle="item.description"
                                ></vs-list-item>
                            </vs-list>
                        </vs-collapse-item>
                    </vs-collapse>
                </div>
            </div>
            <vs-divider border-style="solid" color="dark"></vs-divider>
            <div class="mt-5 mb-3 vx-row">
                <div class="w-1/2 pl-10 vx-col last-state" v-show="lastOrder.reference">
                    Last Scanned Order
                    <br />
                    <br />
                    {{ lastOrder.reference }} - {{ lastOrder.status }}
                    <br />
                    {{ lastOrder.trackingReference }}
                    <br />
                    {{ lastOrder.description }}
                </div>
                <div
                    class="w-1/2 pr-10 text-right vx-col last-state"
                    v-show="lastScanned.product_code"
                >
                    Last Scanned Product
                    <br />
                    <br />
                    {{ lastScanned.product_code }}
                    <br />
                    {{ lastScanned.description }}
                    <br />
                    {{ lastScanned.qty }}
                </div>
            </div>
        </vs-popup>
        <vs-prompt buttons-hidden title="Scan Container ID" :active.sync="showContainerPopup">
            <div class="con-exemple-prompt">
                <vs-input v-model="container_id" class="w-full mb-2" label="Name" size="large" />
                <vs-row
                    vs-align="flex-start"
                    vs-type="flex"
                    vs-justify="flex-end"
                    vs-w="12"
                    class="mt-5"
                >
                    <vs-button color="primary" @click="searchMovement">Search</vs-button>
                </vs-row>
            </div>
        </vs-prompt>
        <iframe id="pdf-frame" style="display: none"></iframe>
    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        flatPickr
    },
    data() {
        return {
            lastOrder: {
                reference: "",
                status: "",
                trackingReference: " ",
                description: ""
            },
            lastScanned: {
                product_code: "",
                description: "",
                qty: ""
            },
            showFull: false,
            isLoading: false,
            data: {
                movement_id: "",
                movement_id_send: "",
                order_source_id: "",
                details: []
            },
            scan: {
                multiplier: 1,
                product_code: "",
                uom: this.$store.state.user.userconfig.base_uom.name,
                pack_id: "",
                batch: "",
                expired_date: "",
                stock_type: this.$store.state.user.userconfig.stock_type.name
            },
            packing: {
                packing_code: "",
                packing_id: 1,
                length: 0,
                width: 0,
                height: 0,
                weight: 0
            },
            state: "container",
            title: "asd",
            show: "",
            alert: "Scan container ID",
            tab_value: 0,
            stockTypes: [],
            do_data: {},
            single_detail: [],
            pack_do_id: null,
            hold: [],
            packingPopup: {
                show: false,
                data: [],
                selected: {}
            },
            showContainerPopup: false,
            container_id: "",
            packing_update: {
                id: null,
                packing_id: '',
                weight: 0,
                height: 0,
                width: 0,
                length: 0
            },
            packingUpdate: false,
            showBtnPrint: false,
            do_id: ""
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        back() {
            this.showFull = false;
            if (this.$route.params.do_id) {
                this.$router.push({
                    name: "delivery-order-view",
                    params: {
                        id: this.$route.params.do_id
                    }
                });
            } else if (this.$route.params.wavepick_id) {
                this.$router.push({
                    name: "wave-pick-planning-view",
                    params: {
                        id: this.$route.params.wavepick_id
                    }
                });
            } else {
                this.$router.go(-1);
            }
        },
        fetchAllData() {
            this.isLoading = true;
            Promise.all([this.$http.post("master/stocktypes/filter/dropdown")])
                .then(
                    this.$http.spread(stocktypes => {
                        this.isLoading = false;
                        this.stockTypes = stocktypes.data;
                        this.focusInput("container");
                    })
                )
                .catch(error => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.fetchAllData();
                        },
                        cancel: () => {
                            this.$router.push({
                                name: "delivery-order-view",
                                params: {
                                    id: this.$route.params.id
                                }
                            });
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                });
        },
        scanContainer() {
            this.isLoading = true;
            this.$http
                .post("outbound/check/getlist", {
                    movement_order_id: this.data.movement_id_send
                })
                .then(res => {
                    this.title =
                        "Picklist Number (" +
                        res.data.type +
                        " SKU) - #" +
                        res.data.id;
                    res.data.details.map(item => (item.hold = false));
                    this.data.details = res.data.details;
                    this.show = "multiple";
                    this.state = "product";
                    this.alert = "Scan product ID";
                    this.tab_value = 0; //d
                    this.data.movement_id = res.data.id;
                    this.focusInput("product");
                    this.showFull = true;
                    this.data.order_source_id = res.data.order_source;
                    this.do_id = res.data.do_id;

                    if(res.data.order_source == '14'){
                        this.showBtnPrint = true;
                    }
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        scanProduct() {
            let error = false;
            let hold = [];
            this.data.details.map(item => {
                if (item.hold) {
                    hold.push(item.id);
                }
            });
            const data = {
                movement_order_id: this.data.movement_id,
                pack_id: this.scan.pack_id == "" ? null : this.scan.pack_id,
                batch: this.scan.batch == "" ? null : this.scan.batch,
                expired_date:
                    this.scan.expired_date == ""
                        ? null
                        : this.scan.expired_date,
                product_code: this.scan.product_code,
                uom: this.scan.uom,
                stock_type: this.scan.stock_type,
                multiplier: this.scan.multiplier,
                hold: this.hold
            };

            if (this.do_data) {
                data.do_id = this.do_data.do_id;
            }

            if (!this.scan.stock_type) {
                error = true;
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "Stock type is required."
                });
            }

            if (this.scan.multiplier < 1) {
                error = true;
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "Multipier cannot be lower than 1."
                });
            }

            // if (!this.scan.product_code) {
            //     error = true;
            //     this.$vs.notify({
            //         color: "danger",
            //         title: "Error",
            //         iconPack: "feather",
            //         icon: "icon-x",
            //         text: "Product code is required."
            //     });
            // }

            if (!this.scan.uom) {
                error = true;
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "UoM is required."
                });
            }

            if (error) {
                return false;
            }

            this.isLoading = true;
            this.$http
                .post("outbound/check/searchorder", data)
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "Scan success"
                    });

                    res.data.details.map(item => (item.hold = false));
                    this.data.details = res.data.details;
                    this.do_data = res.data;
                    if (this.single_detail.length < 1) {
                        this.data.details.map(detail => {
                            if (detail.id == res.data.do_id) {
                                this.single_detail.push(detail);
                            }
                        });
                    } else {
                        this.data.details.map(detail => {
                            if (detail.id == this.single_detail[0].id) {
                                this.single_detail = [];
                                this.single_detail.push(detail);
                            }
                        });
                    }

                    this.show = "single";
                    this.lastScanned.product_code = res.data.product_code;
                    this.lastScanned.description = res.data.description;
                    this.lastScanned.qty = res.data.qty;
                    this.lastOrder.reference = this.single_detail[0].reference;
                    this.lastOrder.trackingReference = this.single_detail[0]
                        .tracking_reference
                        ? this.single_detail[0].tracking_reference
                        : "Tracking reference not found";

                    if (!res.data.finished) {
                        this.scan.product_code = "";
                        this.focusInput("product");
                        this.lastOrder.description = `${this.single_detail[0].checked} of ${this.single_detail[0].total} total checked`;
                        this.lastOrder.status = `CHECKING NOT FINISHED`;
                    } else {
                        this.state = "packing";
                        this.alert = "Scan packaging ID";
                        this.tab_value = 1; // d
                        this.focusInput("packing");
                        this.pack_do_id = this.do_data.do_id;
                        this.lastOrder.description = "Packing Required";
                        this.lastOrder.status = "CHECKING COMPLETED";
                    }

                    this.setHold();
                })
                .catch(error => {
                    this.handleError(error);
                    this.scan.product_code = "";
                })
                .then(() => (this.isLoading = false));
        },
        scanPacking() {
            let error = false;
            let finished = false;
            const data = {
                do_id: this.pack_do_id,
                packing_code: this.packing.packing_code,
                width: this.packing.width,
                length: this.packing.length,
                height: this.packing.height,
                weight: this.packing.weight,
                packing_id: this.packing.packing_id,
                movement_order_id: this.data.movement_id
            };

            if (!this.packing.packing_code) {
                error = true;
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "Packing type is required."
                });
            }

            if (error) {
                return false;
            }

            this.isLoading = true;
            this.$http
                .post("outbound/check/searchpacking", data)
                .then(res => {
                    this.isLoading = false;
                    if (this.single_detail.length > 0) {
                        this.packing.packing_code = "";
                        res.data.details.map(item => (item.hold = false));
                        this.data.details = res.data.details;

                        this.data.details.map(detail => {
                            if (detail.id == this.single_detail[0].id) {
                                this.single_detail = [];
                                this.single_detail.push(detail);
                            }
                        });

                        if (this.single_detail[0].finished) {
                            this.isLoading = true;
                            this.printLabel(this.single_detail[0].id);
                            this.single_detail = [];
                            this.do_data = {};
                            this.show = "multiple";
                            finished = true;
                            this.lastOrder.status = `CHECKING & PACKING FINISHED`;
                            this.lastOrder.color = `success`;
                        } else {
                            this.show = "single";
                        }
                    } else {
                        this.show = "multiple";
                    }

                    this.state = "product";
                    this.alert = "Scan product ID";
                    this.tab_value = 0; //d
                    this.focusInput("product");

                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "Packing success"
                    });

                    this.setHold();
                })
                .catch(error => {
                    this.handleError(error);
                    this.scan.packing_code = "";
                });
        },
        focusInput(refName) {
            setTimeout(() => {
                this.$refs[refName].$el.children[0].children[0].focus();
            }, 100);
        },
        packItem(do_id, multiple) {
            this.pack_do_id = do_id;
            this.$http
                .post("outbound/check/checkpacking", { do_id: this.pack_do_id })
                .then(res => {
                    if (res.data.has_outstanding) {
                        this.state = "packing";
                        this.alert = "Scan packaging ID";
                        this.tab_value = 1; //d
                        this.focusInput("packing");
                    }
                })
                .catch(error => this.handleError(error));
        },
        printLabel(id) {
            this.isLoading = true;
            if(this.data.order_source_id == 14){
                this.$http
                .post(
                    "outbound/deliveryorder/check/print_packing_label",
                    { id: id },
                    { responseType: "json" }
                )
                .then(response => {
                    this.isLoading = false
                    window.open(response.data.url)
                })
                .catch(error => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error saving',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: `Print failed, please check order in GINEE`
                    })
                });
            }else{
                this.$http
                .post(
                    "outbound/deliveryorder/check/print_packing_label",
                    { id: id },
                    { responseType: "blob" }
                )
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: "application/pdf"
                    });

                    var objectURL = URL.createObjectURL(blob);
                    document.querySelector("#pdf-frame").src = "";
                    document.querySelector("#pdf-frame").src = objectURL;
                    objectURL = URL.revokeObjectURL(blob);

                    setTimeout(() => {
                        document
                            .querySelector("#pdf-frame")
                            .contentWindow.print();
                    }, 100);

                    setTimeout(() => {
                        this.isLoading = false;
                    }, 2000);
                })
                .catch(error => {
                    var reader = new FileReader();
                    const globalThis = this;
                    reader.onload = function() {
                        globalThis.isLoading = false;
                        const object = JSON.parse(reader.result);
                        const message = object.message
                            ? object.message
                            : "Something went wrong";

                        globalThis.$vs.notify({
                            color: "danger",
                            title: "Error",
                            iconPack: "feather",
                            icon: "icon-x",
                            text: message
                        });
                    };
                    reader.readAsText(error.response.data);
                });
            }
        },
        viewPacking(id) {
            this.isLoading = true;
            this.$http
                .post("outbound/check/getpackinglist", { do_id: id })
                .then(res => {
                    this.packingPopup.show = true;
                    this.isLoading = false;
                    this.packingPopup.data = res.data.map(item => {
                        return {
                            id: item.id,
                            do_packing_id: item.packing
                                ? item.packing.packing.id
                                : 0,
                            packing_id: item.packing
                                ? item.packing.packing.packing_id
                                : "",
                            product_code: item.do_detail.product.product_code,
                            description: item.do_detail.product.description_1,
                            base_qty: item.check_base_qty,
                            base_uom: item.do_detail.base_uom.name
                        };
                    });
                })
                .catch(error => this.handleError(error));
        },
        holdDo(detail) {
            this.$vs.notify({
                color: "warning",
                title: "Success",
                iconPack: "feather",
                icon: "icon-check",
                text: `Hold - DO #${detail.id}`
            });

            this.hold.push(detail.id);
            if (this.show == "single") {
                this.show = "multiple";
            }

            this.do_data = {};
            this.single_detail = [];

            this.setHold();
        },
        unholdDo(detail) {
            this.$vs.notify({
                color: "success",
                title: "Success",
                iconPack: "feather",
                icon: "icon-check",
                text: `Unhold - DO #${detail.id}`
            });

            this.hold.map((id, index) => {
                if (id == detail.id) {
                    this.hold.splice(index, 1);
                }
            });

            this.setHold();
        },
        setHold() {
            this.data.details.map(item => (item.hold = false));
            this.hold.map(id => {
                this.data.details.map(item => {
                    if (item.id == id) {
                        item.hold = true;
                    }
                });
            });
        },
        updatePacking() {
            const id = this.packingPopup.selected.do_packing_id;
            this.isLoading = true
            this.$http.post('outbound/check/getpackingdetail', {id: id})
            .then(res => {
                this.packing_update.id = res.data.id
                this.packing_update.packing_id = res.data.packing_id
                this.packing_update.width = res.data.width
                this.packing_update.height = res.data.height
                this.packing_update.length = res.data.length
                this.packing_update.weight = res.data.weight
                this.packingPopup.show = false
                this.packingUpdate = true
                this.isLoading = false
            })
            .catch(error => this.handleError(error));
        },
        removePacking() {
            this.isLoading = true;
            const id = this.packingPopup.selected.id;
            this.$http
                .post("outbound/check/removepackingdata", { check_id: id })
                .then(res => {
                    this.packingPopup = {
                        show: false,
                        data: [],
                        selected: {}
                    };
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: `Removed successfully.`
                    });
                    this.scanContainer();
                })
                .catch(error => this.handleError(error));
        },
        searchMovement() {
            this.isLoading = true;
            this.$http
                .post("inventories/movementorder/searchcontainer", {
                    container_id: this.container_id
                })
                .then(res => {
                    this.showContainerPopup = false;
                    this.isLoading = false;
                    this.data.movement_id_send = res.data.movement_id;
                    this.scanContainer();
                })
                .catch(error => this.handleError(error));
        },
        savePacking() {
            this.isLoading = true;
            this.$http.post('outbound/check/updatepackingdetail', this.packing_update)
            .then(res => {
                this.packingUpdate = false;
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: res.data.message || 'Success'
                });
                this.isLoading = false;
            })
            .catch(error => this.handleError(error));
        },
        printPackingLabel() {
            this.isLoading = true

            this.$http.post('outbound/deliveryorder/check/print_packing_label_ginee', {id: this.do_id, qty: 1}, { responseType: 'json' })
            .then(response => {
                this.isLoading = false
                window.open(response.data.url)
            })
            .catch(error => {
                this.isLoading = false
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error saving',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: `Print failed, please check order in GINEE`
                })
            })
        },
    },
    mounted() {
        this.focusInput("container");
        if (this.$route.params.fromDeliveryOrder) {
            this.data.movement_id_send = this.$route.params.movement_id;
            this.data.order_source_id = this.$route.params.order_source_id;
            this.scanContainer();
        } else {
            this.showContainerPopup = true;
        }
    }
};
</script>
